import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { getIncomeBySubjectData } from '../../../requests/api/dashboard';
import { DEFAULT_API_ERROR_MESSAGE } from '../../../utils/errors';
import { useYear } from '../../../hooks/useYear';
import Page from '../../../components/Layout/Page';
import IndicatorsTable from '../components/table';
import { IncomeBySubjectData } from '../types';
import useStyles from './styles';

const IncomeBySubject: React.FC = () => {
  const classes = useStyles();
  const { selectedYear } = useYear();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [
    incomeBySubjectData, setIncomeBySubjectData,
  ] = useState<IncomeBySubjectData>([{
    id: 'totals',
    label: '',
    values: {
      math: { amount: 0, variation: 0 },
      language: { amount: 0, variation: 0 },
      science: { amount: 0, variation: 0 },
      socialStudies: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      paidTotal: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lad',
    label: 'LAD',
    values: {
      math: { amount: 0, variation: 0 },
      language: { amount: 0, variation: 0 },
      science: { amount: 0, variation: 0 },
      socialStudies: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      paidTotal: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lod',
    label: 'LOD',
    values: {
      math: { amount: 0, variation: 0 },
      language: { amount: 0, variation: 0 },
      science: { amount: 0, variation: 0 },
      socialStudies: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      paidTotal: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'em',
    label: 'EM',
    values: {
      math: { amount: 0, variation: 0 },
      language: { amount: 0, variation: 0 },
      science: { amount: 0, variation: 0 },
      socialStudies: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      paidTotal: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'eme',
    label: 'EME',
    values: {
      math: { amount: 0, variation: 0 },
      language: { amount: 0, variation: 0 },
      science: { amount: 0, variation: 0 },
      socialStudies: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      paidTotal: { amount: 0, variation: 0 },
    },
  }]);

  useEffect(() => {
    const fetchIncomeBySubjectData = async () => {
      try {
        const response = await getIncomeBySubjectData(selectedYear);
        setIncomeBySubjectData(response.incomeBySubjectData);
      } catch (err) {
        const e = err as AxiosError;
        enqueueSnackbar(e.response?.data.message || DEFAULT_API_ERROR_MESSAGE, {
          variant: 'error',
        });
      }
    };

    fetchIncomeBySubjectData();
  }, [selectedYear]);

  const handleGoBack = () => {
    history.push('/dashboard/financiero');
  };

  return (
    <Page title="Ingresos por asignatura">
      <Box>
        <Box className={classes.backButtonContainer}>
          <IconButton
            onClick={handleGoBack}
            className={classes.backButton}
            size="small"
          >
            <ArrowBackIos className={classes.backIcon} />
          </IconButton>
          <Typography className={classes.pageTitle}>
            Ingresos por asignatura
          </Typography>
        </Box>

        <Box className={classes.enrollmentsContainer}>
          <IndicatorsTable
            columns={[{
              id: 'math',
              label: 'Matemáticas',
            }, {
              id: 'language',
              label: 'Lenguaje',
            }, {
              id: 'science',
              label: 'Ciencias',
            }, {
              id: 'socialStudies',
              label: 'Sociales',
            }, {
              id: 'total',
              label: 'Totales',
            }, {
              id: 'discounts',
              label: 'Descuentos',
            }, {
              id: 'paidTotal',
              label: 'Total a Pago',
            }]}
            rows={incomeBySubjectData}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default IncomeBySubject;
